import api from "./axios";

export const getMechanicInvoices = async (mechanicId) => {
  if (!mechanicId) throw new Error("شناسه سرویس‌کار مشخص نیست");

  const response = await api.get(`/invoices/mechanic/${mechanicId}`);
  return response.data;
};
